$(function() {
    // Filter and pagination variables
    var currentPage = 1;
    var currentFilters = []; // Changed to array to support multiple selections
    var currentHandleFilters = []; // Changed to array to support multiple selections
    var productsPerPage = parseInt($('.trade-resources-cards-container').data('products-per-page')) || 6;
    var $allCards = $('.trade-resources-card');
    var $visibleCards = $allCards; // Initialize to show all cards initially
    
    // File URLs storage - moved from HTML to JavaScript
    var fileUrls = {};
    var encodedUrls = {};
    var domain = 'https://branchfurniture.com';
    
    console.log('Filter & Pagination Debug:', {
      productsPerPage: productsPerPage,
      totalProducts: $allCards.length
    });
    
    // Initialize file URLs from data attributes and remove them from DOM
    function initializeFileUrls() {
        $('.trade-resources-dropdown-item').each(function() {
            var $item = $(this);
            var originalUrl = $item.attr('data-file-url'); // Read from data attribute instead of href
            var fileType = $item.data('file-type');
            var product = $item.data('product');
            
            if (originalUrl && originalUrl !== '#') {
                // Create unique key for this download
                var urlKey = product + '_' + fileType;
                
                // Store original URL
                fileUrls[urlKey] = originalUrl;
                
                // Store base64 encoded version (extra obfuscation)
                encodedUrls[urlKey] = btoa(originalUrl);
                
                // Remove data-file-url and add data-url-key instead
                $item.removeAttr('data-file-url').attr('data-url-key', urlKey);
            }
        });
        
        console.log('Initialized file URLs for', Object.keys(fileUrls).length, 'downloads');
    }
    
    // Function to get file URL (with decoding if using base64)
    function getFileUrl(urlKey, useEncoded = true) {
        if (useEncoded && encodedUrls[urlKey]) {
            return atob(encodedUrls[urlKey]);
        }
        return fileUrls[urlKey];
    }
    
    // Function to trigger download
    function triggerDownload(url, filename) {
        var tempLink = document.createElement('a');
        tempLink.href = url;
        tempLink.download = filename || '';
        tempLink.style.display = 'none';
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
    }
    
    // URL Parameter Utilities
    function getUrlParameter(name) {
      var url = new URL(window.location);
      return url.searchParams.get(name);
    }
    
    function setUrlParameter(name, value) {
      var url = new URL(window.location);
      if (value && value !== 'all' && value != 1 && value.length > 0) {
        if (Array.isArray(value)) {
          url.searchParams.set(name, value.join(','));
        } else {
          url.searchParams.set(name, value);
        }
      } else {
        url.searchParams.delete(name);
      }
      window.history.replaceState({}, '', url);
    }
    
    function updateUrl() {
      setUrlParameter('category', currentFilters);
      setUrlParameter('handle', currentHandleFilters);
      setUrlParameter('page', currentPage);
    }
    
    // Initialize from URL parameters
    function initializeFromUrl() {
      let params = ['handle', 'category'];
      var urlPage = parseInt(getUrlParameter('page')) || 1;

      params.forEach((param) => {
        var urlCategories = getUrlParameter(`${param}`);
      
        console.log('URL Parameters:', { category: urlCategories, page: urlPage });
        
        // Set filters from URL
        if (urlCategories) {
          var categories = urlCategories.split(',');
          categories.forEach(function(category) {
            var $checkbox = $('.collection-filters__filter-dropdown[data-type="' + param + '"] input[value="' + category + '"]');
            $checkbox.prop('checked', true);
            if ($checkbox.length > 0 && param == 'category') {
              if (currentFilters.indexOf(category) === -1) {
                currentFilters.push(category);
              }
            } else if ($checkbox.length > 0 && param == 'handle') {
              if (currentHandleFilters.indexOf(category) === -1) {
                currentHandleFilters.push(category);
              }
            }
          });
          
          if (currentFilters.length > 0 || currentHandleFilters.length > 0) {
            updateAppliedFilters();
            filterProducts(false); // Don't update URL since we're reading from it
          }
        }
      })

      
      
      // Set page from URL (after filtering)
      if (urlPage > 1) {
        var totalPages = Math.ceil($visibleCards.length / productsPerPage);
        if (urlPage <= totalPages) {
          currentPage = urlPage;
        }
      }
    }
    
    // Dropdown functionality
    function initializeDropdowns() {
      // Handle dropdown button clicks
      $('.collection-filters__filter-button').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var $container = $(this).closest('.collection-filters__filter-container');
        var isActive = $container.attr('data-active') === 'true';
        
        // Close all other dropdowns
        $('.collection-filters__filter-container').attr('data-active', 'false');
        $('.collection-filters').attr('data-dropdown-open', 'false');
        
        // Toggle current dropdown
        if (!isActive) {
          $container.attr('data-active', 'true');
          $('.collection-filters').attr('data-dropdown-open', 'true');
        }
      });
      
      // Handle dropdown close button
      $('.collection-filters__filter-dropdown-close-icon').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.collection-filters__filter-container').attr('data-active', 'false');
        $('.collection-filters').attr('data-dropdown-open', 'false');
      });
      
      // Close dropdowns when clicking outside
      $(document).on('click', function(e) {
        if (!$(e.target).closest('.collection-filters__filter-container').length) {
          $('.collection-filters__filter-container').attr('data-active', 'false');
          $('.collection-filters').attr('data-dropdown-open', 'false');
        }
      });
      
      // Handle checkbox changes
      $('.collection-filters__filter-dropdown input[type="checkbox"]').on('change', function() {
        var value = $(this).val();
        var isChecked = $(this).is(':checked');
        var type = $(this).closest('.collection-filters__filter-dropdown').attr('data-type')
        if(type == 'category'){
        if (isChecked) {
            if (currentFilters.indexOf(value) === -1) {
              currentFilters.push(value);
            }
          } else {
            var index = currentFilters.indexOf(value);
            if (index > -1) {
              currentFilters.splice(index, 1);
            }
          } 
        } else {
          if (isChecked) {
            if (currentHandleFilters.indexOf(value) === -1) {
              currentHandleFilters.push(value);
            }
          } else {
            var index = currentHandleFilters.indexOf(value);
            if (index > -1) {
              currentHandleFilters.splice(index, 1);
            }
          } 
        }
        
        console.log('Filter changed:', value, 'Checked:', isChecked, 'Current filters:', currentFilters);
        
        updateAppliedFilters();
        filterProducts(true);
      });
    }
    
    // Update applied filters display
    function updateAppliedFilters() {
      for (let i = 0; i < 2; i++) {
        let type;
        let filters;
        if(i == 0){
          type = 'category'
          filters = currentFilters;
        } else {
          type = 'handle'
          filters = currentHandleFilters;
        }

        var $container = $(`.collection-filters__applied-filters-container[data-type="${type}"] `);
        var $filtersWrapper = $( `.collection-filters__applied-filters-container[data-type="${type}"] .collection-filters__applied-filters`);
        var $clearButton = $(`.collection-filters__applied-filters-container[data-type="${type}"] .collection-filters__clear-applied-filters `);
        
      // Remove existing applied filter items (but keep clear button)
      $filtersWrapper.find('.collection-filters__applied-single-filter').remove();
      
      if (filters.length > 0) {
        // Show applied filters container
        $container.attr('data-visible', 'true');
        
        // Add applied filter items
        filters.forEach(function(filterValue) {
          // Find the display name for this filter value
          var $checkbox = $('.collection-filters__filter-dropdown[data-type="' + type + '"] input[value="' + filterValue + '"]');
          var displayName = $checkbox.siblings('span').text() || filterValue;
          
          var $appliedFilter = $('<div class="collection-filters__applied-single-filter swiper-slide" data-filter="category" data-option="' + filterValue + '">' +
            '<span>' + displayName + '</span>' +
            '<button class="collection-filters__applied-single-filter-close">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">' +
                '<path d="M4 3.61125L7.11125 0.5L8 1.38875L4.88875 4.5L8 7.61125L7.11125 8.5L4 5.38875L0.888749 8.5L0 7.61125L3.11125 4.5L0 1.38875L0.888749 0.5L4 3.61125Z" fill="#314438"></path>' +
              '</svg>' +
            '</button>' +
          '</div>');
          
          $filtersWrapper.prepend($appliedFilter);
        });
        
        // Handle remove individual filter
        $(`.collection-filters__applied-filters-container[data-type="${type}"] .collection-filters__applied-single-filter-close`).on('click', function() {
          var $appliedFilter = $(this).closest('.collection-filters__applied-single-filter');
          var filterValue = $appliedFilter.attr('data-option');
          
          // Uncheck the corresponding checkbox
          $('.collection-filters__filter-dropdown[data-type="' + type + '"] input[value="' + filterValue + '"]').prop('checked', false);
          
          // Remove from current filters
          var index = filters.indexOf(filterValue);
          if (index > -1) {
            filters.splice(index, 1);
          }
          
          updateAppliedFilters();
          filterProducts(true);
        });
        
      } else {
        // Hide applied filters container
        $container.attr('data-visible', 'false');
      }
      
      // Update applied filters data attribute
      var appliedFiltersData = currentFilters.map(function(filter) {
        return {"filter": "category", "option": filter};
      });
      var appliedHandleFiltersData = currentHandleFilters.map(function(filter) {
        return {"filter": "handle", "option": filter};
      });
      $container.attr('data-applied-filters', JSON.stringify(appliedFiltersData));
      $container.attr('data-applied-handle-filters', JSON.stringify(appliedHandleFiltersData));

      }

      
    }
    
    // Handle clear all filters
    $('.collection-filters__clear-applied-filters').on('click', function(e) {
      e.preventDefault();
      let type = e.target.closest('.collection-filters__applied-filters-container') && e.target.closest('.collection-filters__applied-filters-container').getAttribute('data-type');
      $('.collection-filters__filter-dropdown input[type="checkbox"]').prop('checked', false);
      
      // Clear current filters
      if(type == 'category'){
        currentFilters = [];
      } else {
        currentHandleFilters = [];
      }
      
      updateAppliedFilters();
      filterProducts(true);
    });
    
    // Adjust products per page for mobile
    function getAdjustedProductsPerPage() {
      if (window.innerWidth <= 767) {
        return Math.floor(productsPerPage / 3) * 4;
      }
      return productsPerPage;
    }
    
    // Filter products by category
    function filterProducts(updateUrlFlag = true) {
      currentPage = 1; // Reset to first page when filtering
      $visibleCards = $allCards;
      $allCards.removeClass('filtered-out');
      for (let i = 0; i < 2; i++) {
        let type;
        let filters;
        if(i == 0){
          type = 'category'
          filters = currentFilters;
        } else {
          type = 'handle'
          filters = currentHandleFilters;
        }
        if (filters.length > 0) {
          // Show products that match ANY of the selected categories
          var matchingCards = [];
          filters.forEach(function(category) {
            var categoryCards = $allCards.filter('[data-' + type + '="' + category + '"]');
            categoryCards.each(function() {
              if (matchingCards.indexOf(this) === -1) {
                matchingCards.push(this);
              }
            });
          });
          
          $visibleCards = $(matchingCards);
          $allCards.addClass('filtered-out');
          $visibleCards.removeClass('filtered-out');
        }
      }

      
      
      // console.log('Filtered to categories:', currentFilters, 'Found:', $visibleCards.length, 'products');
      
      // Update URL if requested
      if (updateUrlFlag) {
        updateUrl();
      }
      
      // Update pagination for filtered results
      initializePagination();
    }
    
    // Initialize pagination
    function initializePagination() {
      productsPerPage = getAdjustedProductsPerPage();
      var totalFilteredProducts = $visibleCards.length;
      var totalPages = Math.ceil(totalFilteredProducts / productsPerPage);
      
      console.log('Initializing pagination:', {
        totalFilteredProducts: totalFilteredProducts,
        productsPerPage: productsPerPage,
        totalPages: totalPages
      });
      
      // Assign page numbers to visible cards only
      $visibleCards.each(function(index) {
        var pageNumber = Math.floor(index / productsPerPage) + 1;
        $(this).attr('data-filtered-page', pageNumber);
      });
      
      // Show/hide pagination controls
      if (totalPages > 1) {
        $('.trade-resources-pagination').show();
        createPaginationNumbers(totalPages);
      } else {
        $('.trade-resources-pagination').hide();
      }
      
      // Show current page
      showPage(currentPage);
      updatePaginationControls(totalPages);
    }
    
    // Show specific page of filtered results
    function showPage(page, updateUrlFlag = true) {
      currentPage = page;
      console.log('Showing page:', page, 'of', Math.ceil($visibleCards.length / productsPerPage), 'total pages');
      
      // Hide all cards first
      $allCards.removeClass('visible').hide();
      
      // Show cards for current page of visible results
      var startIndex = (page - 1) * productsPerPage;
      var endIndex = startIndex + productsPerPage;
      
      var $pageCards = $visibleCards.slice(startIndex, endIndex);
      $pageCards.addClass('visible').show();
      
      // Handle centering for few cards
      var $container = $('.trade-resources-cards-container');
      if ($pageCards.length < 3 && window.innerWidth > 767) {
        $container.addClass('few-cards');
      } else {
        $container.removeClass('few-cards');
      }
      
      // Update URL if requested
      if (updateUrlFlag) {
        updateUrl();
      }
      
      console.log('Showing', $pageCards.length, 'cards on page', page);
    }
    
    // Create pagination number buttons
    function createPaginationNumbers(totalPages) {
      var numbersContainer = $('.pagination-numbers');
      numbersContainer.empty();
      
      for (var i = 1; i <= totalPages; i++) {
        var numberLink = $('<a href="#" data-page="' + i + '">' + i + '</a>');
        numbersContainer.append(numberLink);
      }
    }
    
    // Update pagination controls state
    function updatePaginationControls(totalPages) {
      var $prevBtn = $('.trade-resources-pagination .prev');
      var $nextBtn = $('.trade-resources-pagination .next');
      
      if (currentPage === 1) {
        $prevBtn.addClass('disabled').attr('aria-hidden', 'true').attr('tabindex', '-1');
      } else {
        $prevBtn.removeClass('disabled').removeAttr('aria-hidden').removeAttr('tabindex');
      }
      
      if (currentPage === totalPages) {
        $nextBtn.addClass('disabled').attr('aria-hidden', 'true').attr('tabindex', '-1');
      } else {
        $nextBtn.removeClass('disabled').removeAttr('aria-hidden').removeAttr('tabindex');
      }
      
      $('.pagination-numbers a').removeClass('active').removeAttr('aria-hidden').removeAttr('tabindex');
      $('.pagination-numbers a[data-page="' + currentPage + '"]').addClass('active').attr('aria-hidden', 'true').attr('tabindex', '-1');
    }
    
    // Handle pagination clicks
    $(document).on('click', '.trade-resources-pagination .prev:not(.disabled)', function(e) {
      e.preventDefault();
      if (currentPage > 1) {
        showPage(currentPage - 1, true);
        updatePaginationControls(Math.ceil($visibleCards.length / productsPerPage));
      }
    });
    
    $(document).on('click', '.trade-resources-pagination .next:not(.disabled)', function(e) {
      e.preventDefault();
      var totalPages = Math.ceil($visibleCards.length / productsPerPage);
      if (currentPage < totalPages) {
        showPage(currentPage + 1, true);
        updatePaginationControls(totalPages);
      }
    });
    
    $(document).on('click', '.pagination-numbers a', function(e) {
      e.preventDefault();
      var page = parseInt($(this).data('page'));
      if (page !== currentPage) {
        showPage(page, true);
        updatePaginationControls(Math.ceil($visibleCards.length / productsPerPage));
      }
    });
    
    // Handle browser back/forward buttons
    window.addEventListener('popstate', function(event) {
      console.log('Browser navigation detected, reinitializing from URL...');
      
      // Reset current state
      currentFilters = [];
      currentHandleFilters = [];
      $('.collection-filters__filter-dropdown input[type="checkbox"]').prop('checked', false);
      
      // Initialize from URL
      initializeFromUrl();
      initializePagination();
    });
    
    // Handle window resize
    var resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        var newProductsPerPage = getAdjustedProductsPerPage();
        if (newProductsPerPage !== productsPerPage) {
          productsPerPage = newProductsPerPage;
          initializePagination();
        }
      }, 250);
    });
    
    // Form submission tracking
    var formSubmitted = sessionStorage.getItem('branch_trade_form_submitted') === 'true';
    
    if (formSubmitted) {
      $('.trade-resources-dropdown-item').addClass('download-unlocked');
    }
    
    function openTradePaywallForm(productTitle, fileType, fileUrl) {
      var $popup = $('.trade-resources-products-section .chat-with-sales-popup-trade:last');
      
      console.log('Opening trade form popup:', $popup.length);
      
      if ($popup.length === 0) {
        console.error('Trade popup not found');
        return;
      }
      
      $popup.find('#subscription-popup-title').text('Design Resources Download');
      
      // var paywallDescription = 'Download ' + fileType + ' files for ' + productTitle + '. Transform your vision into reality with our curated swatches, CAD blocks, and 3D models—everything you need to bring your client\'s office to life.';
      // $popup.find('p').first().text(paywallDescription);
      
      $popup.data('requested-file-url', fileUrl);
      $popup.data('requested-file-type', fileType);
      $popup.data('requested-product', productTitle);
      
      if ($popup.find('input[name="contact[product]"]').length === 0) {
        $popup.find('form').append('<input type="hidden" name="contact[product]" value="' + productTitle + '">');
        $popup.find('form').append('<input type="hidden" name="contact[requested_file_type]" value="' + fileType + '">');
      } else {
        $popup.find('input[name="contact[product]"]').val(productTitle);
        $popup.find('input[name="contact[requested_file_type]"]').val(fileType);
      }
      
      $popup.find('.success-p').text('Thank you! Your download will begin shortly. You may download additional files without resubmitting your information.');
      
      Simplistic.openModal($popup, 'regular');
    }
    
    // Function to open swatch paywall form (new - for physical swatches)
    function openSwatchPaywallForm(productTitle, fileType, fileUrl) {
      var $popup = $('.chat-with-sales-popup-swatch:last');
      
      console.log('Opening swatch form popup:', $popup.length);
      
      if ($popup.length === 0) {
        console.error('Swatch popup not found');
        return;
      }
      
      $popup.find('#subscription-popup-title').text('Swatches Request');
      
      var paywallDescription = 'Need to see it in person? Bring your vision to life with physical swatches, mailed to you for your convenience.';
      $popup.find('p').first().text(paywallDescription);
      
      $popup.data('requested-file-url', fileUrl);
      $popup.data('requested-file-type', fileType);
      $popup.data('requested-product', productTitle);
      
      if ($popup.find('input[name="contact[product]"]').length === 0) {
        $popup.find('form').append('<input type="hidden" name="contact[product]" value="' + productTitle + '">');
        $popup.find('form').append('<input type="hidden" name="contact[requested_file_type]" value="' + fileType + '">');
      } else {
        $popup.find('input[name="contact[product]"]').val(productTitle);
        $popup.find('input[name="contact[requested_file_type]"]').val(fileType);
      }
      
      $popup.find('.success-p').text('Thank you! We will send you physical swatches shortly.');
      
      Simplistic.openModal($popup, 'regular');
    }
    
    // Updated: Handle existing trade resources dropdown clicks (no more direct href)
    $('.trade-resources-dropdown-item').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var $link = $(this);
      var fileType = $link.data('file-type');
      var product = $link.data('product');
      var urlKey = $link.attr('data-url-key');
      
      if (formSubmitted && urlKey) {
        var fileUrl = getFileUrl(urlKey);
        if (fileUrl) {
          triggerDownload(fileUrl);
          
          if (typeof gtag !== 'undefined') {
            gtag('event', 'file_download', {
              'file_type': fileType,
              'product': product,
              'event_category': 'Trade Resources'
            });
          }
        }
      } else if (urlKey) {
        var fileUrl = getFileUrl(urlKey);
        openTradePaywallForm(product, fileType, fileUrl);
      }
      
      return false;
    });
    
    // Handle left button clicks (Digital Swatch Catalog - Trade Form)
    $(document).on('click', '.open-trade-form-left', function(e) {
      e.preventDefault();
      
      var $link = $(this);
      var product = $link.data('product') || 'Digital Swatch Catalog';
      var fileType = $link.data('file-type') || 'PDF';
      var urlKey = $link.attr('data-url-key');
      var fileUrl = urlKey ? getFileUrl(urlKey) : ($link.data('file-url') || $link.attr('href'));
      
      if (formSubmitted && fileUrl) {
        triggerDownload(fileUrl);
        
        if (typeof gtag !== 'undefined') {
          gtag('event', 'file_download', {
            'file_type': fileType,
            'product': product,
            'event_category': 'Trade Resources'
          });
        }
      } else {
        openTradePaywallForm(product, fileType, fileUrl);
      }
      
      return false;
    });
    
    // Handle right button clicks (Physical Swatches - Swatch Form)
    $(document).on('click', '.open-swatch-form-right', function(e) {
      e.preventDefault();
      
      var $link = $(this);
      var product = $link.data('product') || 'Physical Swatches';
      var fileType = $link.data('file-type') || 'Swatches';
      var urlKey = $link.attr('data-url-key');
      var fileUrl = urlKey ? getFileUrl(urlKey) : ($link.data('file-url') || $link.attr('href'));
      
      openSwatchPaywallForm(product, fileType, fileUrl);
      
      return false;
    });
    
    // Generic handler for any anchor tag with trade form classes
    $(document).on('click', '.open-trade-form', function(e) {
      e.preventDefault();
      
      var $link = $(this);
      var product = $link.data('product') || 'Trade Resource';
      var fileType = $link.data('file-type') || 'File';
      var urlKey = $link.attr('data-url-key');
      var fileUrl = urlKey ? getFileUrl(urlKey) : ($link.data('file-url') || $link.attr('href'));
      
      if (formSubmitted && fileUrl) {
        triggerDownload(fileUrl);
      } else {
        openTradePaywallForm(product, fileType, fileUrl);
      }
      
      return false;
    });
    
    // Generic handler for any anchor tag with swatch form classes
    $(document).on('click', '.open-swatch-form', function(e) {
      e.preventDefault();
      
      var $link = $(this);
      var product = $link.data('product') || 'Physical Swatches';
      var fileType = $link.data('file-type') || 'Swatches';
      var urlKey = $link.attr('data-url-key');
      var fileUrl = urlKey ? getFileUrl(urlKey) : ($link.data('file-url') || $link.attr('href'));
      
      openSwatchPaywallForm(product, fileType, fileUrl);
      
      return false;
    });
    
    // Initialize if there are products
    if ($allCards.length > 0) {
      console.log('Initializing filter and pagination system...');
      // Start with all products visible (no filter applied)
      $visibleCards = $allCards;
      
      // Initialize file URLs (remove from DOM, store in JS)
      initializeFileUrls();
      
      // Initialize dropdown functionality
      initializeDropdowns();
      
      // Initialize from URL parameters first
      initializeFromUrl();
      
      // Then set up pagination
      initializePagination();
    }
});
